import React, { Component } from 'react'

class OnClickOutside extends Component {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick.bind(this), false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick.bind(this), false)
  }

  handleClick = (e) => {
    if (!this.node || this.node.contains(e.target)) return
    this.props.onClickOutside()
  }

  render() {
    return (
      <div className={this.props.className || ''} ref={node => this.node = node}>
        {this.props.children}
      </div>
    )
  }
}

export default OnClickOutside


// WEBPACK FOOTER //
// ./src/components/ColorPicker/OnClickOutside/index.js